<!---------------------------------new ui---------------------------------------------------->

<section class="content-header ">
   
    <div class="row mb-2 ">
    <div class="col-sm-6">
    <h1>Product Stock</h1>
    </div>
    </div>
  
    </section>
    <!--------------loader-------------------------->
    <div *ngIf=loaderShown class="loader"></div>
    <!----------------------------------------------->
    
    <section class="content">
    
    <div class="card"  *ngIf=tableShown >
    <div class="card-header">
    <div class="card-tools">
    <button type="button" class="btn btn-tool" data-card-widget="collapse" title="Collapse">
    <i class="fas fa-minus"></i>
    </button>
    <button type="button" class="btn btn-tool" data-card-widget="remove" title="Remove">
    <i class="fas fa-times"></i>
    </button>
    </div>
    </div>
    <div class="card-body p-0">
    <table class="table table-striped projects">
    <thead>
    <tr>
   

    <th style="width: 35%" >
    User Name
    </th>

    <th style="width: 25%">
    Warehouse Name
    </th>

    <th style="width: 30%">
    Date And Time
    </th>
    
     
    <th>
    </th>
   
    </tr>
    </thead>
    <tbody>

    <tr *ngFor="let c of output">
    <td>
    <a>    
    {{c.submitted_person_name}}
    </a>
    </td>

    <td>
    {{c.warehouse_name}}
    </td>
        
    
    <td>
    {{DateFormat(c.created_date)}}
    </td>

    
    <td class="project-actions text-right">
    <a class="btn btn-primary btn-sm" (click)="ViewDetails(c._id);">
    <i class="fas fa-folder">
    </i>
    View
    </a>
    <!----
    <a class="btn btn-danger btn-sm left"  data-toggle="modal" data-target="#modal-sm">
    <i class="fas fa-trash">
    </i>
    Delete
    </a>
    ------->
    </td>
    </tr>
    

    </tbody>
    </table>
    </div>
    
    </div>
    
    </section>
<!---------------------paging------------------------------------->
<ul class="pagination" *ngIf=tableShown>
    <li class="paginate_button page-item previous" id="example2_previous">
    <a  (click)="clicks_previous()" aria-controls="example2" data-dt-idx="0" tabindex="0" class="page-link count">Previous</a></li>
    
    <li class="paginate_button page-item "><a aria-controls="example2" data-dt-idx="1" tabindex="0" class="page-link count">{{ New_count+1}}</a></li>
               
    <li class="paginate_button page-item next" id="example2_next" >
    <a  (click)="clicks_next()"  aria-controls="example2" data-dt-idx="7" tabindex="0" class="page-link">Next</a></li>
    </ul>
      